import {
	authInterceptorFactory,
	axios,
	interceptAndNormalizeResponse,
	requestHeaderNormalizerInterceptor
} from "@teaming/io-helpers";

const IO_SURVEY_NAMESPACE = "survey";

export default function ioSurveyFactory( { config: { baseUri, }, authService, } ) {
	axios.defaults.baseURL = baseUri;
	axios.interceptors.request.use( requestHeaderNormalizerInterceptor );
	axios.interceptors.request.use( authInterceptorFactory( { authService, } ) );
	axios.interceptors.response.use( ...interceptAndNormalizeResponse() );

	const surveyMethods = {
		async fetchSurveyTemplate( options = { templateId: "0000000-0000-0000-0000-000000000000", } ) {
			const { templateId, } = options;
			const url = `/surveytemplate/${ templateId }`;
			return await axios( {
				method: "get",
				url,
			} );
		},

		async createNewTeamHealthSurvey( { teamId, newSurveyEmailMessage, } ) {
			const url = "/survey/";
			return await axios( {
				method: "post",
				url,
				data: { teamId, newSurveyEmailMessage, },
			} );
		},

		async fetchTeamSurveys( { teamId, } ) {
			const url = `/survey/?teamId=${ teamId }`;
			return await axios( {
				method: "get",
				url,
			} );
		},

		async fetchSurvey( { surveyInstanceId, } ) {
			const url = `/survey/${ surveyInstanceId }`;
			return await axios( {
				method: "get",
				url,
			} );
		},

		async saveSurveyResponse( { surveyInstanceId, data, } ) {
			const url = `/survey/${ surveyInstanceId }/response`;
			return await axios( {
				method: "post",
				url,
				data: { data, },
			} );
		},

		async publishSurveyResults( { surveyInstanceId, } ) {
			const url = `/survey/${ surveyInstanceId }/publishedsurvey`;
			return await axios( {
				method: "post",
				url,
			} );
		},
	};

	return {
		namespace: IO_SURVEY_NAMESPACE,
		...surveyMethods,
	};
}
